import { UiHistoryAlt } from '@vyaguta/vyaguta-icons/ui';

import { COLORS } from 'constants/color';
import { MY_TEAM_LABELS } from 'constants/myTeam';

import AttendanceWifiLog from 'components/common/attendance/AttendanceWifiLog';

import { convertTimeToAMPM } from 'utils/time';

import type { MyTeamRow, TeamUser } from '../types';
import { getAttendanceStatusMeta } from '../utils/attendanceStatus';

interface AttendanceContextPopupProps {
  rowData: MyTeamRow;
  onViewFullClockInHistory?: (user: TeamUser) => void;
  showClockInTimeHistory?: boolean;
}

const AttendanceContextPopup = ({
  rowData,
  onViewFullClockInHistory,
  showClockInTimeHistory,
}: AttendanceContextPopupProps) => {
  if (!rowData?.user) {
    return null;
  }

  const { user } = rowData;
  const { checkInTime } = rowData?.attendance?.today || {};
  const { Icon, className, label, color, hasLogo, logoColor, isWeekend, isHoliday } = getAttendanceStatusMeta(rowData);
  const clockInValue = checkInTime ? convertTimeToAMPM(checkInTime) : MY_TEAM_LABELS.PLACEHOLDER;

  if (!showClockInTimeHistory) {
    return (
      <div className="my-team__badge-icon d-flex gap-px-8 p-10 justify-content-center align-items-center">
        <AttendanceWifiLog
          Icon={Icon}
          color={color || COLORS.white}
          className={className}
          hasLogo={hasLogo}
          logoColor={logoColor}
        />
        <p className="my-team__attendance-popup__label-only font-size-12">{label}</p>
      </div>
    );
  }

  return (
    <div className="my-team__attendance-popup">
      <div className="my-team__attendance-popup__header">
        <div className="my-team__attendance-popup__meta">
          <AttendanceWifiLog
            Icon={Icon}
            color={color || COLORS.white}
            className={className}
            hasLogo={hasLogo}
            logoColor={logoColor}
          />
          <p className="my-team__attendance-popup__label">{label}</p>
        </div>
        {showClockInTimeHistory && !isWeekend && !isHoliday ? (
          <div className="my-team__attendance-popup__clock">
            <p className="my-team__attendance-popup__clock-title">{MY_TEAM_LABELS.CLOCK_IN_TIME}</p>
            <p className="my-team__attendance-popup__clock-value">{clockInValue}</p>
          </div>
        ) : null}
      </div>
      {showClockInTimeHistory && (
        <div className="my-team__attendance-popup__footer">
          <button
            type="button"
            onClick={() => {
              onViewFullClockInHistory?.(user);
            }}
            className="my-team__attendance-popup__history-btn"
          >
            <UiHistoryAlt size={14} />
            {MY_TEAM_LABELS.VIEW_FULL_CLOCK_IN_LOGS}
          </button>
        </div>
      )}
    </div>
  );
};

export default AttendanceContextPopup;
